import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from '../../../shared/i18n';
import { useDashboard } from '../hooks/useDashboard';
import { AddGuardian } from './AddGuardian';

/**
 * AddGuardianPage - Standalone page for adding a guardian to the family
 */
export const AddGuardianPage = () => {
  const { data, isLoading, error } = useDashboard();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(null);

  if (isLoading) {
    return (
      <div className="bg-light min-vh-100">
        <div className="container py-4">
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">{t('common.loading')}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-light min-vh-100">
        <div className="container py-4">
          <div className="alert alert-danger">
            {t('common.error')}: {error.message}
          </div>
        </div>
      </div>
    );
  }

  const { family } = data;

  const handleSuccess = (message) => {
    // Store success message in sessionStorage for the guardians page to display
    sessionStorage.setItem('flash_notice', message);
    navigate('/guardians');
  };

  const handleCancel = () => {
    navigate('/guardians');
  };

  return (
    <AddGuardian
      familyName={family.name}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  );
};

export default AddGuardianPage;
